import { useEffect } from "react";
import { useHistory } from "react-router-dom";

const useScrollPositionRestoration = (storageKey: string, dependencies?: React.DependencyList) => {
  const history = useHistory();

  // To do: store paginated results and cursor using react window in case of cooking history (remove dependencies) 
  useEffect(() => {
    const scrollHeight = sessionStorage.getItem(storageKey);
    const initialScrollHeight = scrollHeight !== null ? Number(scrollHeight) : 0;

    if (window.scrollY <= initialScrollHeight) {
      window.scrollTo(0, initialScrollHeight);
    }
  }, dependencies);

  useEffect(() => {
    const unlisten = history.listen(() => {
      sessionStorage.setItem(storageKey, window.scrollY.toString());
    });
    return () => {
      unlisten();
    };
  }, [history]);
};

export default useScrollPositionRestoration;
